import styled from "styled-components";

export const Container = styled.div`
    padding: ${(props) => props.theme.padding.mobile} 20px;

    @media (min-width: 640px) {
        padding: ${(props) => props.theme.padding.primary} 20px;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    max-width: 700px;
    margin: 0 auto;

    > h1 {
        text-align: center;
    }
`;

export const FormComunicacaoAtraso = styled.form`
    margin-bottom: 32px;
    display: grid;
    width: 100%;

    gap: 24px 16px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-areas: "motivo motivo motivo outroMotivo" "observacao observacao observacao observacao" "button button button button";

    > :nth-child(1) {
        grid-area: motivo;
    }

    > :nth-child(2) {
        grid-area: outroMotivo;
    }

    > :nth-child(3) {
        grid-area: observacao;
    }
    > :nth-child(4) {
        grid-area: button;
    }

    @media (min-width: 640px) {
        grid-template-columns: 1fr;
        grid-template-areas: "motivo" "outroMotivo " "observacao" "button";
    }
`;